import { useMemo } from 'react';
import { tv } from 'tailwind-variants';

interface Props {
	onClick: (value: boolean) => void;
	isParking: boolean;
	disabled?: boolean;
}

export const ParkingButton = ({
	onClick,
	isParking,
	disabled = false,
}: Props) => {
	const buttonVariants = tv({
		base: 'w-full h-full rounded-3xl text-5xl font-bold transition disabled:bg-gray-800 shadow-xl',
		variants: {
			isParking: {
				true: 'bg-red-600 hover:bg-red-700 active:bg-red-700',
				false: 'bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-700',
			},
		},
	});

	const content = useMemo(() => {
		if (disabled) {
			return '주차 불가 구역';
		}
		return isParking ? '주차 종료' : '주차 시작';
	}, [isParking, disabled]);

	return (
		<button
			onClick={() => onClick(!isParking)}
			className={buttonVariants({ isParking })}
			disabled={disabled}
		>
			{content}
		</button>
	);
};
